export class ParametriOpzionaliDocumento {
  id?: string;
  parametro: string;
  valore: string;
}
